import { CLIENT_CONTAINER, CLIENT_PLATFORM } from '@lowcode/mcp-protocol/src/base/common';
import { Platform, Source } from '../types/domain';
import { string2PositiveInt, stringToFloat } from './number';
import { getRiskRequest } from './risk';
/**
 * 根据 commonParams.platform（CLIENT_PLATFORM 枚举）派生业务请求的 Platform 枚举值
 */
export function getRequestPlatform(platform) {
    return platform === CLIENT_PLATFORM.DP ? Platform.DIANPING : Platform.MEITUAN;
}
/**
 * 根据 commonParams.clientContainer（CLIENT_CONTAINER 枚举）派生业务请求的 Source 枚举值
 */
export function getRequestSource(clientContainer) {
    switch (clientContainer) {
        case CLIENT_CONTAINER.DIANPING_APP:
        case CLIENT_CONTAINER.DIANPING_WEBVIEW:
            return Source.DIANPING_APP;
        case CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM:
            return Source.WECHAT_MEITUAN_MINI;
        case CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM:
            return Source.WECHAT_HOTEL_MINI;
        case CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM:
            return Source.WECHAT_DIANPING_MINI;
        default:
            return Source.MEITUAN_APP;
    }
}
/**
 * 从 commonParams 中一次性提取 platform 和 source 枚举值
 * commonParams 可能为 undefined（页面初始化未就绪时），此时降级到默认值
 */
export async function getRequestBaseParams(commonParams) {
    const feCommonParams = {
        userId: commonParams?.userId,
        locateCityId: string2PositiveInt(commonParams?.cityInfo?.locCityId),
        cityId: string2PositiveInt(commonParams?.cityInfo?.cityId),
        latitude: stringToFloat(commonParams?.lat),
        longitude: stringToFloat(commonParams?.lng),
        uuid: commonParams?.uuid,
        version: commonParams?.appVersion,
        riskRequest: await getRiskRequest(commonParams),
        platform: getRequestPlatform(commonParams?.platform ?? CLIENT_PLATFORM.MT),
        source: getRequestSource(commonParams?.clientContainer ?? CLIENT_CONTAINER.MEITUAN_APP)
    };
    return feCommonParams;
}
